
import { Autocomplete, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Link, Stack, TextField } from "@mui/material"
import PaperDraggable from "../../../../../../../components/PaperDraggable"
import { useCallback, useState } from "react"
import { enqueueSnackbar } from "notistack"
import { useModalDetalheTitulo } from "../../../../MIContasReceber/ModalDetalheTituloContext"
import { TTitulosPossiveisSafraEdi } from "../../../../../../../types/api/financeiro/detalhar-integracao-bancaria"
import SelectIndicarTituloSafra from "./SelectIndicarTituloSafra"

export default function DialogIndicarTitulo({
    open,
    titulo,
    opcoes,
    tipo,
    observacao = null,
    handleClose,
    handleSubmit,
    handleLimpar = () => { }
}: DialogIndicarTituloProps) {

    const { openModal } = useModalDetalheTitulo();
    const [value, setValue] = useState<string | null>(titulo);
    const [motivo, setMotivo] = useState<string | null>(observacao);
    const [inputValue, setInputValue] = useState('');

    //valores importantes
    const isSafraEdi = tipo === "Safra EDI";
    const isCnab240 = tipo === "CNAB240";
    const opcoesSafra = isSafraEdi ? opcoes as TTitulosPossiveisSafraEdi[] : [];
    const opcoesCnab240 = isCnab240 ? opcoes as TTitulosPossiveisSafraEdi[] : [];
    const opcoesPadrao = !isSafraEdi && !isCnab240 ? opcoes as string[] : [];
    //

    //funções manipuladoras
    const handleConfirm = useCallback(() => {
        if (!value) {
            enqueueSnackbar("Error ao confirmar título", { variant: "error" });
            return;
        }
        if ((isSafraEdi || isCnab240) && value === "Resolvido por fora" && !motivo) {
            enqueueSnackbar("Por favor, informe o motivo da resolução por fora", { variant: "warning" });
            return;
        }
        if ((isSafraEdi || isCnab240) && value === "Resolvido por fora" && motivo) {
            handleSubmit(value, motivo);
            handleClose();
            return;
        }
        handleSubmit(value);
        handleClose();
    }, [value, motivo, handleSubmit, handleClose, isSafraEdi, isCnab240]);

    const handleVisualizarDetalhe = (value: string) => {
        if (!value?.includes('/')) value += '/01'
        openModal(value)
    }

    const handleLimparCampo = () => {
        handleLimpar();
        handleClose();
    }
    //

    return (
        <Dialog
            open={Boolean(open)}
            onClose={handleClose}
            PaperComponent={PaperDraggable}
            aria-labelledby="draggable-dialog-title"
            scroll="body"
            maxWidth="sm"
            fullWidth
        >
            <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
                Indicar título
            </DialogTitle>
            <DialogContent>
                {
                    isSafraEdi &&
                    <Stack py={1} direction={'column'} spacing={2}>
                        <SelectIndicarTituloSafra
                            onLimpar={handleLimparCampo}
                            onChange={(valor) => setValue(valor)}
                            value={value || null}
                            opcoes={opcoesSafra}
                        />
                        {
                            value && value === 'Resolvido por fora' &&
                            <TextField
                                required
                                label="Observação"
                                fullWidth
                                multiline
                                rows={3}
                                value={motivo || ''}
                                onChange={(e) => setMotivo(e.target.value)}
                            />
                        }
                    </Stack>

                }
                {
                    isCnab240 &&
                    <Stack py={1} direction={'column'} spacing={2}>
                        <SelectIndicarTituloSafra
                            onLimpar={handleLimparCampo}
                            onChange={(valor) => setValue(valor)}
                            value={value || null}
                            opcoes={opcoesCnab240}
                        />
                        {
                            value && value === 'Resolvido por fora' &&
                            <TextField
                                required
                                label="Observação"
                                fullWidth
                                multiline
                                rows={3}
                                value={motivo || ''}
                                onChange={(e) => setMotivo(e.target.value)}
                            />
                        }
                    </Stack>

                }
                {
                    !isSafraEdi && !isCnab240 &&
                    <>
                        <Box py={1}>
                            <Autocomplete
                                options={opcoesPadrao}
                                fullWidth
                                renderInput={(params) => <TextField
                                    {...params}
                                    label="Títulos"
                                />}
                                value={value}
                                onChange={(_: any, newValue: string | null) => {
                                    setValue(newValue);
                                }}
                                inputValue={inputValue}
                                onInputChange={(_, newInputValue) => {
                                    setInputValue(newInputValue);
                                }}
                            />
                        </Box>
                        {
                            value &&
                            <Box display="flex" justifyContent="flex-end">
                                <Link
                                    component="button"
                                    variant="subtitle2"
                                    underline="hover"
                                    onClick={() => handleVisualizarDetalhe(value)}
                                >
                                    Visualizar detalhe
                                </Link>
                            </Box>
                        }
                    </>
                }
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={handleClose}
                >
                    Cancelar
                </Button>
                <Button
                    autoFocus
                    disabled={!Boolean(value)}
                    variant="contained"
                    onClick={handleConfirm}
                >
                    Confirmar
                </Button>
            </DialogActions>
        </Dialog>
    )
}

interface DialogIndicarTituloProps {
    open: boolean,
    titulo: string | null,
    opcoes: string[] | TTitulosPossiveisSafraEdi[],
    tipo: string,
    observacao?: string | null,
    handleClose: () => void
    handleSubmit: (arg: string, motivo?: string) => void
    handleLimpar?: () => void
}
